import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16cbda64"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16cbda64')) {
      api.createRecord('16cbda64', component.options)
    } else {
      api.reload('16cbda64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=16cbda64", function () {
      api.rerender('16cbda64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/PageFooter/index.vue"
export default component.exports